import { provideAnalyticsService, useAnalyticService, } from "./useAnalyticService";
import TrackingEventService from "./analytics.service";
export function initAnalyticsIdf(gtmOptions, useAuthService, analyticsApiHost) {
    let analyticsOptions;
    if (analyticsApiHost || window.env.ANALYTICS_API_HOST) {
        analyticsOptions = {
            domain: analyticsApiHost || window.env.ANALYTICS_API_HOST,
            accessTokenGetter: async () => useAuthService().getAccessToken(),
            isAuthenticated: async () => useAuthService().isAuthenticated(),
        };
    }
    const trackingEventService = provideAnalyticsService(gtmOptions, analyticsOptions);
    trackingEventService?.trackEvent("app_init", {});
}
export { provideAnalyticsService, useAnalyticService, TrackingEventService, };
//# sourceMappingURL=index.js.map